import React from 'react'
import { ToastContainer } from 'react-toastify'
import Spinner from '../../Spinner/spinner'
import UseCampaign from '../hooks/useCampaign'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { TextField } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import JoditEditor from "jodit-react";



const EmailCampaign = () => {
  const {
    navigate,
    handleChange,
    mailSend,
    spinner,
    allList,
    emailInputs,
  } = UseCampaign()
  return (
    <>
      <ToastContainer />
      <section>
        <div className="cus-padd cusheight ">
          {spinner && <Spinner />}
          <header>
            <h2 className='page-tittle d-flex align-items-center'>
              <ChevronLeftIcon sx={{ fontSize: "30px" }} className='cursor' onClick={() => navigate(-1)} /> {emailInputs.subject}
            </h2>
            <hr />
          </header>

          <div className="row border">
            <div className="col-12 mb-2">
              <Autocomplete multiple id="tags-standard"
                options={allList}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => handleChange('to', value)}
                renderInput={(params) => (<TextField {...params} variant="standard" label="To" />)}
              />
            </div>
            <div className="col-12 my-2">
              <Autocomplete multiple id="tags-standard"
                options={allList}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => handleChange('cc', value)}
                renderInput={(params) => (<TextField  {...params} variant="standard" label="Cc" />)}
              />
            </div>
            <div className="col-12 my-2">
              <Autocomplete multiple id="tags-standard"
                options={allList} getOptionLabel={(option) => option?.name}
                onChange={(e, value) => handleChange('bcc', value)}
                renderInput={(params) => (<TextField {...params} variant="standard" label="Bcc" />)}
              />
            </div>
            <div className="col-12 my-2">
              <TextField className="w-100" id="standard-basic" label="Subject" variant="standard" value={emailInputs.subject} />
            </div>
            <div className="col-12 my-2">
              <JoditEditor value={emailInputs.template} config={{ readonly: true }} />
            </div>
            <div className='my-3 d-flex justify-content-end'>
              <button type="submit" className="btn btn-primary px-4" onClick={mailSend}>Send</button>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default EmailCampaign